import {
    BarContainer,
    LegendColor,
    LegendPercentage,
    LegendType,
    NoDataContainer,
} from "app/pages/keyword-research/website-analysis/pages/seo-overview/summary/intent-distribution/IntentDistributionStyledComponents";
import { SummaryLoader } from "app/pages/keyword-research/website-analysis/pages/seo-overview/summary/styledComponents";
import { TrafficShare } from "pro-features/components/TrafficShare/src/TrafficShare";
import { NO_DATA_SIGN } from "app/filters/const";
import { BaseFlex, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { IIntentDistributionChartData } from "./intentDistributionChartTypes";
import { getColorByType, mapDataToIntentItemConfigs } from "./intentDistributionChartUtils";

const defaultData: IIntentDistributionChartData = {
    informational: 0,
    transactional: 0,
    navigational: 0,
    local: 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    job_search: 0,
};

interface IIntentDistributionChartProps {
    data?: IIntentDistributionChartData;
    isLoading?: boolean;
    height?: number;
    minWidthToShowData?: number;
    noDataContainerWidth?: string;
    noDataContainerHeight?: string;
}

export const IntentDistributionChart = ({
    data = defaultData,
    isLoading = false,
    height = 25,
    minWidthToShowData = 10,
    noDataContainerWidth = "314px",
    noDataContainerHeight = "24px",
}: IIntentDistributionChartProps) => {
    const hasData = Object.values(data).some((percentage) => percentage > 0);
    const normalizedData = mapDataToIntentItemConfigs(data);

    if (isLoading) {
        return <SummaryLoader />;
    }

    return (
        <>
            <BarContainer>
                {hasData ? (
                    <TrafficShare
                        data={normalizedData}
                        height={height}
                        minWidthToShowData={minWidthToShowData}
                    />
                ) : (
                    <NoDataContainer
                        width={noDataContainerWidth}
                        height={noDataContainerHeight}
                    />
                )}
            </BarContainer>
            <FlexColumn gap="8px">
                {normalizedData.map((item, index) => (
                    <BaseFlex
                        alignItems="center"
                        key={index}
                    >
                        <LegendColor color={getColorByType(item.type)} />
                        <LegendType>{item.name}</LegendType>
                        <LegendPercentage>{hasData ? item.text : NO_DATA_SIGN}</LegendPercentage>
                    </BaseFlex>
                ))}
            </FlexColumn>
        </>
    );
};
